// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calls-selector[data-v-40409137] {
  height: 60px;
  width: 60px;
  background-color: gray;
  position: absolute;
  border-radius: 50%;
  -webkit-app-region: no-drag;
  cursor: pointer;
}
.calls-selector .show-calls-btn[data-v-40409137] {
  height: 60px;
  width: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  font-size: 28px;
  color: white;
  background-color: #ccd1d3;
}
.calls-selector .show-calls-btn i.fa-sort-up[data-v-40409137] {
  margin-top: 10px;
}
.calls-selector .show-calls-btn i.fa-sort-down[data-v-40409137] {
  margin-top: -8px;
}
.calls-selector .impulse-animation[data-v-40409137] {
  -webkit-animation: impulse-40409137 2s linear infinite;
  animation: impulse-40409137 2s linear infinite;
}
@-webkit-keyframes impulse-40409137 {
0% {
    color: #ffffff;
}
50% {
    color: rgba(255, 255, 255, 0);
}
100% {
    color: #ffffff;
}
}
@keyframes impulse-40409137 {
0% {
    color: #ffffff;
}
50% {
    color: rgba(255, 255, 255, 0);
}
100% {
    color: #ffffff;
}
}
.calls-selector .impulse-animation-background[data-v-40409137] {
  -webkit-animation: impulsebackground-40409137 2s linear infinite;
  animation: impulsebackground-40409137 2s linear infinite;
}
@-webkit-keyframes impulsebackground-40409137 {
0% {
    background-color: rgba(0, 0, 0, 0.6);
}
50% {
    background-color: rgba(255, 255, 255, 0);
}
100% {
    background-color: rgba(0, 0, 0, 0.6);
}
}
@keyframes impulsebackground-40409137 {
0% {
    background-color: rgba(0, 0, 0, 0.6);
}
50% {
    background-color: rgba(255, 255, 255, 0);
}
100% {
    background-color: rgba(0, 0, 0, 0.6);
}
}
.call[data-v-40409137] {
  height: 60px;
  width: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-bottom: 2px;
  -webkit-app-region: no-drag;
}
.call .icon-image[data-v-40409137] {
  height: 100%;
  width: 100%;
}
.call .icon-pause-btn[data-v-40409137] {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  -webkit-app-region: no-drag;
}
.call .icon-pause-btn #pause[data-v-40409137] {
  position: absolute;
  color: white;
  font-size: 36px;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/phone/CallsSelector.vue"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sDAAsD;EACtD,8CAA8C;AAChD;AACA;AACA;IACI,cAAc;AAClB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,cAAc;AAClB;AACA;AACA;AACA;IACI,cAAc;AAClB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,cAAc;AAClB;AACA;AACA;EACE,gEAAgE;EAChE,wDAAwD;AAC1D;AACA;AACA;IACI,oCAAoC;AACxC;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,oCAAoC;AACxC;AACA;AACA;AACA;IACI,oCAAoC;AACxC;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,oCAAoC;AACxC;AACA;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB","sourcesContent":[".calls-selector[data-v-40409137] {\n  height: 60px;\n  width: 60px;\n  background-color: gray;\n  position: absolute;\n  border-radius: 50%;\n  -webkit-app-region: no-drag;\n  cursor: pointer;\n}\n.calls-selector .show-calls-btn[data-v-40409137] {\n  height: 60px;\n  width: 60px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  font-size: 28px;\n  color: white;\n  background-color: #ccd1d3;\n}\n.calls-selector .show-calls-btn i.fa-sort-up[data-v-40409137] {\n  margin-top: 10px;\n}\n.calls-selector .show-calls-btn i.fa-sort-down[data-v-40409137] {\n  margin-top: -8px;\n}\n.calls-selector .impulse-animation[data-v-40409137] {\n  -webkit-animation: impulse-40409137 2s linear infinite;\n  animation: impulse-40409137 2s linear infinite;\n}\n@-webkit-keyframes impulse-40409137 {\n0% {\n    color: #ffffff;\n}\n50% {\n    color: rgba(255, 255, 255, 0);\n}\n100% {\n    color: #ffffff;\n}\n}\n@keyframes impulse-40409137 {\n0% {\n    color: #ffffff;\n}\n50% {\n    color: rgba(255, 255, 255, 0);\n}\n100% {\n    color: #ffffff;\n}\n}\n.calls-selector .impulse-animation-background[data-v-40409137] {\n  -webkit-animation: impulsebackground-40409137 2s linear infinite;\n  animation: impulsebackground-40409137 2s linear infinite;\n}\n@-webkit-keyframes impulsebackground-40409137 {\n0% {\n    background-color: rgba(0, 0, 0, 0.6);\n}\n50% {\n    background-color: rgba(255, 255, 255, 0);\n}\n100% {\n    background-color: rgba(0, 0, 0, 0.6);\n}\n}\n@keyframes impulsebackground-40409137 {\n0% {\n    background-color: rgba(0, 0, 0, 0.6);\n}\n50% {\n    background-color: rgba(255, 255, 255, 0);\n}\n100% {\n    background-color: rgba(0, 0, 0, 0.6);\n}\n}\n.call[data-v-40409137] {\n  height: 60px;\n  width: 60px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  margin-bottom: 2px;\n  -webkit-app-region: no-drag;\n}\n.call .icon-image[data-v-40409137] {\n  height: 100%;\n  width: 100%;\n}\n.call .icon-pause-btn[data-v-40409137] {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: 50%;\n  -webkit-app-region: no-drag;\n}\n.call .icon-pause-btn #pause[data-v-40409137] {\n  position: absolute;\n  color: white;\n  font-size: 36px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
